import type { AgentDocUpdate } from '@streamlain/copilot-realtime-contract';
import { buildLocalWorkflowDocId } from '@streamlain/workflow-field-schemas';

export function createAgentOrigin(
  agent: AgentDocUpdate
): AgentDocUpdate & { kind: 'agent' } {
  return {
    kind: 'agent',
    ...agent,
    targets: agent.targets.map(target =>
      (target.kind === 'workflow' || target.kind === 'node') &&
      target.workflowId
        ? { ...target, docId: buildLocalWorkflowDocId(target.workflowId) }
        : target
    ),
  };
}
